import React, {useEffect} from 'react'
import './header.css'
import CTA from './CTA'
import KOLAPO from '../../assets/kolapo.png'
import HeaderSocials from './HeaderSocials'
import AOS from 'aos'
import 'aos/dist/aos.css'
const Header = () => {
  useEffect(() => {
    AOS.init({duration:2000})
  })
  return (
    <div>
      <header id='home'>
        <div className="container header_container">
          <h5 data-aos="fade-up">Hello I'm</h5>
          <h1 data-aos="fade-up">Kolawole Kolapo </h1>
          <h5 className="text-light" data-aos="fade-up">Software Developer</h5>
          
          <CTA />
          <HeaderSocials />
          
          
          <div className="me" >
            <img className='img__float' src={KOLAPO} alt='' />
          </div>
          <a href="#contact" className='scroll__down'>Scroll Down</a>
         
         
        </div>
      </header>
    </div>
  )
}

export default Header